import type {Context} from '../types';

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  return {
    needed: jsonNode.type === 'Image' && Boolean(data.val) && Boolean(data.img),
    logData: {
      msg: 'Delete corrupt expression data from 0x0 images',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.val;

      if (data.type) {
        // eslint-disable-next-line webflow/no-delete
        delete data.type;
      }
    },
  };
};
